import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MaterialUiButton from '@material-ui/core/Button';
import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({});

interface IButtonAttributes {
    children: any;
    classes: any;
    disabled?: boolean;
    fullWidth?: boolean;
    href?: string;
    onClick?: (event: React.MouseEvent) => void;
    onMouseDown?: (event: React.MouseEvent) => void;
    onMouseUp?: (event: React.MouseEvent) => void;
    onMouseLeave?: (event: React.MouseEvent) => void;
    className?: any;
    color?: 'default' | 'inherit' | 'primary' | 'secondary';
    variant?: 'text' | 'outlined' | 'contained';
}

const Button = (props: IButtonAttributes) => {
    return (
        <MaterialUiButton {...props} />
    );
};

export default withStyles(styles)(Button);
